export const clearStore = "SESSION_CLEAR_STORE";


export const listLoadStart = 'SESSION_LIST_LOAD_START';
export const listLoadSuccess = 'SESSION_LIST_LOAD_SUCCESS';
export const listLoadFail = 'SESSION_LIST_LOAD_FAIL';

export const itemDeleteStart = 'SESSION_DELETE_START';
export const itemDeleteSuccess = 'SESSION_DELETE_SUCCESS';
export const itemDeleteFail = 'SESSION_DELETE_FAIL';